
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/inquiry/write",
      function () {
        return require("private-next-pages/support/inquiry/write.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/inquiry/write"])
      });
    }
  